import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import 'firebase/auth';
import Button from '../../components/button/index.tsx';
import FirebaseContext from '../../context/firebase.context';
import UsuarioContext from '../../context/usuario.context';
import { notify } from '../../functions/notifications';
import LogoAgsafe from '../../assets/agsafebk.png';
import { FormataTelefone } from '../../functions/helper';
import { TermosDeUso } from '../../components/modals';
import './cadastro.scss';

function Cadastro() {
  const { setUsuario, usuario } = useContext(UsuarioContext);
  const {
    Cadastrar, Logout, logado, VerificaLogin,
  } = useContext(FirebaseContext);
  const { email } = usuario;
  const history = useHistory();
  VerificaLogin();

  function handleChange({ target }) {
    const { name, value } = target;
    const change = name === 'whatsApp' ? FormataTelefone(value) : value;
    setUsuario((prevState) => ({
      ...prevState, [name]: change,
    }));
  }

  return (
    <div id="cadastrar-novo-usuario">
      <TermosDeUso aceite={{ show: false }} />
      <main>
        <section className="header-novo-usuario">
          <div className="texto-header">
            <span className="criar-conta">
              Criar uma conta gratuíta.
            </span>
            <span className="cadastre-se">
              Cadastre-se para ter acesso a uma conta AGSAFE.
            </span>
          </div>
          <div className="logotipo-cadastro">
            <img src={LogoAgsafe} alt="Logo" />
          </div>
        </section>

        <section className="formulario-cadastro">
          <div className="inputs-cadastro">
            <label className="nome">
              <span>
                Nome
              </span>
              <input
                onChange={handleChange}
                type="text"
                name="nome"
                placeholder="Digite seu nome"
              />
            </label>
            <label className="whatsApp">
              <span>
                WhatsApp
              </span>
              <input
                onChange={handleChange}
                type="text"
                name="whatsApp"
                value={usuario.whatsApp || ''}
                placeholder="(00)9.0000-0000"
              />
            </label>
            {(!logado) && (
            <label className="email">
              <span>
                Email
              </span>
              <input
                onChange={handleChange}
                type="email"
                name="email"
                placeholder="Digite seu email"
                value={usuario.email || ''}
              />
            </label>
            )}
            <label className="senha">
              <span>
                Senha
              </span>
              <input
                onChange={handleChange}
                type="password"
                name="senha"
                placeholder="Senha"
              />
            </label>
            <label className="contraSenha">
              <span>
                Repita a Senha
              </span>
              <input
                onChange={handleChange}
                type="password"
                name="contraSenha"
                placeholder="Digite sua senha"
              />
            </label>
          </div>

          {logado && (
          <div className="texto-nao-e">
            <button
              onClick={() => Logout()}
              type="button"
              className="criar-conta buttons-transparent"
            >

              <span>
                {`Não é ${email}?`}
              </span>

            </button>
          </div>
          )}

          <div className="buttons-novo-usuario">
            <Button
              onClick={() => {
                if (usuario.whatsApp && usuario.whatsApp.length === 14) {
                  Cadastrar();
                } else {
                  notify('error', 'WhatsApp inválido');
                }
              }}
            >
              CADASTRAR
            </Button>

            <div>
              <button className="buttons-transparent" type="button" onClick={() => history.push('/login')}>
                <span>
                  Já tem uma conta? Efetuar login.
                </span>
              </button>
            </div>

            <div className="desktop-termos">
              <button className="buttons-transparent" type="button" data-toggle="modal" data-target="#modal-termos-de-uso">
                <span>
                  Ao se cadastrar você concorda com os termos de uso.
                </span>
              </button>
            </div>
            <div className="mobile-termos">
              <button className="buttons-transparent" type="button" data-toggle="modal" data-target="#modal-termos-de-uso">
                <span>
                  Visualizar os termos de uso.
                </span>
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Cadastro;
